<template>
  <div>
    <v-snackbar
      v-model="snackbar"
      color="primary"
      :timeout="2000"
      location="bottom right"
    >
      <v-icon size="xx-large">mdi-content-copy</v-icon>
      <h3>{{ $t("basics.copied") }}!</h3>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "copyDisplay",

  props: ["showCopiedDisplay"],

  data() {
    return {
      snackbar: false,
    };
  },

  watch: {
    showCopiedDisplay() {
      this.snackbar = true;
    },
  },
};
</script>
